import React, { FC } from 'react';
import DataTableCell from '@salesforce/design-system-react/components/data-table/cell';
import Button from '@salesforce/design-system-react/components/button';
import { BrowserRouter as Router, RouteComponentProps, withRouter } from 'react-router-dom';
import AgencyTransaction from '../../Shared/AgencyTransaction';

interface EventId {
  caseExternalId: string;
  eventId: string;
  caseNumber: string;
  orderId: string;
  integrationStatus: string;
  status?: string;
  isAgencyRecord: boolean;
}

// interface for props that the data table cell is getting default from data table.
export interface Props extends RouteComponentProps {
  children?: FC;
  item?: EventId;
  type?: string;
}

const OrderRequestIdCell: FC<Props> = ({
  item = {
    caseExternalId: null,
    eventId: null,
    caseNumber: null,
    orderId: null,
    integrationStatus: null,
    status: null,
    isAgencyRecord: false,
  },
  history,
  type = null,
}) => {
  const {
    eventId,
    caseNumber,
    caseExternalId,
    orderId,
    integrationStatus,
    status,
    isAgencyRecord,
  } = item;
  const goToOrderDetails = (): void => {
    // if (type !== 'Review') {
    if (type && orderId && (type !== 'Review' || integrationStatus === 'Failed')) {
      history.push('/OrdersUsageDetails', { orderId, type, status });
    } else {
      history.push('/OrdersUsageDetails', { externalId: caseExternalId, type });
    }
    // }
  };

  return (
    <Router>
      <DataTableCell title={eventId || ''}>
        <AgencyTransaction isAgencyRecord={isAgencyRecord} />
        <Button
          label={eventId || caseNumber || 'TBD'}
          variant="base"
          onClick={goToOrderDetails}
          style={{ margin: '2px 2px 2px 2px' }}
        />
      </DataTableCell>
    </Router>
  );
};

export default withRouter(OrderRequestIdCell);
